import {
    Dialog,
    DialogContent,
    DialogTitle,
    Box,
    Typography,
    IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';

import { CustomerTypes, UserTypes } from '../../types';
import { Team } from '../../types/teams.types';
import { UserForm } from './user-form';

const COLORS = {
    textMuted: '#6B7A90',
    textFaint: '#9AA4B5',
};

interface Props {
    visible: boolean;
    isEdit: boolean;
    onClose: () => void;
    selectedUser?: UserTypes.Model;
    allTeams: Team[];
    setShowActiveUsers: (flag: string) => void;
    toggleRefresh: boolean;
    showActiveUsers?: string;
    setToggleRefresh: (flag: boolean) => void;
    customerSettings: CustomerTypes.OnboardingForm;
    isCustomerSettingsLoading: boolean;
}

export const AddNewUsersModal: React.FC<Props> = ({
    visible,
    isEdit,
    onClose,
    selectedUser,
    allTeams,
    toggleRefresh,
    setToggleRefresh,
    customerSettings,
    isCustomerSettingsLoading,
}) => {
    const handleSuccess = () => {
        setToggleRefresh(!toggleRefresh);
        onClose();
    };

    return (
        <Dialog
            open={visible}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            PaperProps={{
                sx: { borderRadius: '12px', maxHeight: '90vh' },
            }}
        >
            <DialogTitle
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    pb: 0.5,
                }}
            >
                <Box>
                    <Typography sx={{ fontSize: '18px', fontWeight: 600, color: '#1a1a2e' }}>
                        {isEdit ? 'Edit POM User' : 'Add New POM User'}
                    </Typography>
                    {!isEdit && (
                        <Typography sx={{ fontSize: '13px', color: COLORS.textMuted, mt: '2px' }}>
                            Register a new user to your organization.
                        </Typography>
                    )}
                </Box>
                <IconButton onClick={onClose} size="small" sx={{ color: COLORS.textFaint }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ pt: '12px !important' }}>
                <UserForm
                    isEdit={isEdit}
                    selectedUser={selectedUser}
                    allTeams={allTeams}
                    customerSettings={customerSettings}
                    isCustomerSettingsLoading={isCustomerSettingsLoading}
                    onCancel={onClose}
                    onSuccess={handleSuccess}
                />
            </DialogContent>
        </Dialog>
    );
};
